
import { menuTimingList, TimingObj, MenuTimingArray, MenuTimingItem, EnableTime, TimingData } from "./types";
export const menuTimingInitialState: MenuTimingArray = [
  {
    key: "Monday",
    value: [{ start: "", end: "" }],
    enabled: false,
    isoWeekday: 1
  },
  {
    key: "Tuesday",
    value: [{ start: "", end: "" }],
    enabled: false,
    isoWeekday: 2
  },
  {
    key: "Wednesday",
    value: [{ start: "", end: "" }],
    enabled: false,
    isoWeekday: 3
  },
  {
    key: "Thursday",
    value: [{ start: "", end: "" }],
    enabled: false,
    isoWeekday: 4
  },
  {
    key: "Friday",
    value: [{ start: "", end: "" }],
    enabled: false,
    isoWeekday: 5
  },
  {
    key: "Saturday",
    value: [{ start: "", end: "" }],
    enabled: false,
    isoWeekday: 6
  },
  {
    key: "Sunday",
    value: [{ start: "", end: "" }],
    enabled: false,
    isoWeekday: 7
  },
]
export function generateMenuTimingArray(menuTimingList: menuTimingList, timeZone?: string) {
  const newMenuTimingArray = [...menuTimingInitialState];

  newMenuTimingArray.forEach((itemInArray: MenuTimingItem, index: number) => {
    const value: EnableTime[] = [];
    let enabledTemp = false
    menuTimingList?.forEach((itemInList: TimingObj) => {
      if (itemInList.iso_weekday === itemInArray.isoWeekday) {

        value.push({
          start: itemInList.start_time.slice(0, -3),
          end: itemInList.end_time.slice(0, -3)
        })
        enabledTemp = itemInList.enabled

      }
    })
    if (value.length > 0) {
      newMenuTimingArray[index] = {
        ...newMenuTimingArray[index],
        value: value,
        enabled: enabledTemp
      }
    }
  })
  return newMenuTimingArray;
}

export function generateMenuTimingData(menuTiming: MenuTimingArray, venueId: string, menuID?: string, timeZone?: string): TimingData {
  const menuTimingData: menuTimingList = [];
  let hasEmptyRow = false;
  let hasActiveDay = false;
  menuTiming.forEach(({ enabled, value, isoWeekday }: MenuTimingItem) => {
    value.forEach((item: EnableTime) => {
      if (enabled) {
        hasActiveDay = true;
      }
      if (item.start !== '' && item.end !== '') {
        let timingObject = {
          iso_weekday: isoWeekday,
          start_time: item.start + ":00",
          end_time: item.end + ":00",
          enabled: enabled,
          venue_id: venueId,
        }
        if (menuID) {
          // @ts-ignore
          timingObject['menu_id'] = menuID
        }
        menuTimingData.push(timingObject)
      }
      else if (enabled) {
        hasEmptyRow = true;
      }
    })
  })
  return {
    timing_data: menuTimingData,
    hasEmptyRow,
    hasActiveDay
  };
}